import React from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';

interface Props {
  className?: string;
  heightClass?: string; // tailwind height classes like h-12
}

const CooperationLoader: React.FC<Props> = ({ className = '', heightClass = 'h-32 sm:h-40 md:h-48 lg:h-56 xl:h-64' }) => {
  const { t } = useLanguage();

  const logoStyle: React.CSSProperties = {
    animation: 'pulse 1.5s infinite ease-in-out'
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="text-center text-lg sm:text-xl font-semibold mb-12 flex items-center justify-center gap-0.5">
        <span>{t('loading1')}</span>
        <span className="loading-dot">.</span>
        <span className="loading-dot dot2">.</span>
        <span className="loading-dot dot3">.</span>
      </div>

      <div className="flex items-center gap-4 sm:gap-6 md:gap-8">
        <img
          src="/ima_logo.png"
          alt="Scan ID Logo"
          className={`${heightClass} w-auto`}
          style={{ ...logoStyle, animationDelay: '0s' }}
        />
        <img
          src="/health360_logo.png"
          alt="Partner Logo"
          className={`${heightClass} w-auto`}
          style={{ ...logoStyle, animationDelay: '0.75s' }}
        />
      </div>
    </div>
  );
};

export default CooperationLoader; 